"use strict";
import React from "react";
import { Modal } from "react-bootstrap";

const initComponent = (flex = window.flex) => {

    class PageModalContent extends React.Component {
        state = {
            doNotShowAgain: false
        };

        toggleDoNotShow = () => {
            this.setState({ doNotShowAgain: !this.state.doNotShowAgain })
        };

        closeModal = (content) => {
            let doNotShowAgain = this.state.doNotShowAgain;
            if (doNotShowAgain) {
                flex.removePageModalContent(content.key, content.postId);
                this.setState({ doNotShowAgain: false });
            } else {
                flex.removePageModalContent(content.key);
            }
        };

        render() {
            const props = this.props;
            const pageContent = props.pageModalContent;
            const spanStyle = { padding: "20px", display: "block", fontSize: "12px" };

            if (!pageContent || !pageContent.length) return false;

            return (
                <div>
                    {pageContent.map((content, index) => {

                        const isRequired = content.isRequired;
                        const allowDoNotShowAgain = content.allowDoNotShowAgain;
                        const modalClassName = content.modalClass || '';
                        const self = this;

                        const doNotShowAgain = allowDoNotShowAgain ? (
                            <div className="col-md-6">
                                <label className="checkbox">
                                    <input type="checkbox" id={content.key} value={content.key} name={content.key} key={'check_' + content.key} onClick={() => self.toggleDoNotShow()} />
                                    Don't show this again
            			    </label>
                            </div>) : (false);

                        return (<Modal key={index + "modal"} show={true} className={modalClassName} backdrop={content.backdrop} bsSize="large" onHide={(isRequired ? () => { return false } : () => self.closeModal(content))}>
                            <Modal.Header closeButton={!isRequired} >
                            </Modal.Header>
                            <Modal.Body>
                                <span dangerouslySetInnerHTML={{ __html: content.summary }}></span>
                                {
                                    !isRequired ? (
                                        <div key={'div' + content.key} className="row" style={{ marginTop: "40px" }}>
                                            {doNotShowAgain}
                                            <div className="col-md-6">
                                                <a className="btn" data-dismiss="modal" onClick={() => self.closeModal(content)}>Continue to Site &gt;&gt;&gt;</a>
                                            </div>
                                        </div>) : (false)
                                }
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="form-group">
                                    {
                                        isRequired ? (
                                            <div key={'div' + content.key} className="checkbox-group checkbox-inline">
                                                <span>
                                                    <input type="checkbox" id={content.key} value={content.key} name={content.key} key={'check_' + content.key} onClick={() => flex.removePageModalContent(content.key, content.postId)} />
                                                    <label htmlFor={content.key} key={'label' + content.key}>I accept</label>
                                                </span>
                                            </div>) : (false)
                                    }
                                </div>

                            </Modal.Footer>
                        </Modal>)
                    })}
                </div>
            );
        }
    }

    return PageModalContent;
};

module.exports = initComponent;
